import AXIOS from "@/axios";
import {
  APIResponse,
  User,
  UserFilterListResponse,
  UserQuery,
} from "@/types/user.model";

export const createUserService = (payload: any) => {
  return AXIOS.post<APIResponse<User>>("/user/v1/create", payload);
};

export const updateUserService = (userId: string, payload: any) => {
  return AXIOS.put<APIResponse<User>>(`/user/v1/update/${userId}`, payload);
};

export const getUserDetailService = (userId: string) => {
  return AXIOS.get<APIResponse<User>>(`/user/v1/view/${userId}`);
};

export const getAllUsersService = (query: UserQuery) => {
  return AXIOS.get<APIResponse<User[]>>("/user/v1/list", {
    params: query,
  });
};

export const getUserFilterListService = ({ showAll }: { showAll: boolean }) => {
  const params: { [key: string]: number } = {};

  if (showAll) {
    params["xactive"] = 1;
  }

  return AXIOS.get<UserFilterListResponse[]>("/base/dn/v1/user", {
    params,
  });
};
